/**
 * API Service for per-merchant Firebase configuration.
 * Super Admin only.
 *
 * Backend: Alaric.Services.Messaging - FirebaseConfigController
 * Base route: /api/v1/firebase-config
 */

import { Result } from "../../../models/Result";
import {
    FirebaseConfigDto,
    UpsertFirebaseConfigRequest,
} from "../../../models/notifications";
import { messagingHttpService } from "./MessagingHttpService";

const BASE_PATH = "/api/v1/firebase-config";

class FirebaseConfigApiService {
    /**
     * Get Firebase config for a merchant (projectId + isActive only, never credentials).
     */
    get = async (merchantId: number): Promise<Result<FirebaseConfigDto>> => {
        return messagingHttpService.get<FirebaseConfigDto>(
            `${BASE_PATH}?merchantId=${merchantId}`
        );
    };

    /**
     * Create or update Firebase credentials for a merchant.
     */
    createOrUpdate = async (request: UpsertFirebaseConfigRequest): Promise<Result<{ id: string; merchantId: number }>> => {
        return messagingHttpService.post<{ id: string; merchantId: number }>(BASE_PATH, request);
    };

    /**
     * Remove Firebase credentials for a merchant.
     */
    delete = async (merchantId: number): Promise<Result<void>> => {
        return messagingHttpService.delete<void>(`${BASE_PATH}/${merchantId}`);
    };
}

const firebaseConfigApiService = new FirebaseConfigApiService();

export { firebaseConfigApiService };
